import { useSelector } from "react-redux";
import AdminDashboard from "../Admin/AdminDashboard";
import LoginPage from "./LoginPage";
const ProtectiveAdminPage = () => {
  const { adminTokenDetails } = useSelector((state) => state.mainReducer);

  const isAdmin =
    adminTokenDetails &&
    Object.keys(adminTokenDetails)?.length > 0 &&
    adminTokenDetails?.admin === "true";

  return isAdmin ? <AdminDashboard /> : <LoginPage />;
};

export default ProtectiveAdminPage;
